export default __webpack_public_path__ + "static/media/Kiss.3159bfc6.png";